import { Box } from '@jfs/ui-new'
import * as React from 'react'
import { ReactElement } from 'react'
import ReactDOM from 'react-dom'
import { Dimensions } from 'react-native'
import { getRangeDate } from '../../util/util'
import { CalendarTypes } from '../Calendar'
import CalendarViewModal from '../CalendarViewModal'
import { ModBox } from '../ModifiedBox/ModifiedBox'
import { returnLeftValue, returnTopValue, returnTopValueCalendar } from './LayoutFunction'
import { styles } from './styles'
import { timerSeparator } from './TimerUISeparator'

const windowHeight = Dimensions.get('window').height

export const renderTimerPortal = (
  setModalVisibility: (val: boolean) => void,
  showModal: boolean,
  layoutValue: {} | any,
  rendeTimerDropdown: (val: string) => void,
): React.ReactPortal => {
  return ReactDOM.createPortal(
    renderVirtualTimerModal(setModalVisibility, showModal, layoutValue, rendeTimerDropdown),
    document.body,
  )
}

export const renderCalendarPortal = (
  toggleCalendarModal: () => void,
  layoutValueCalendar: {} | any,
  onDateSelected: (date: any) => void,
  isCalendarVisible: boolean,
): React.ReactPortal => {
  return ReactDOM.createPortal(
    renderVirtualCalendarModal(toggleCalendarModal, layoutValueCalendar, onDateSelected, isCalendarVisible),
    document.body,
  )
}

const renderVirtualTimerModal = (
  setModalVisibility: (val: boolean) => void,
  showModal: boolean,
  layoutValue: {} | any,
  rendeTimerDropdown: (val: string) => void,
): ReactElement => {
  return (
    <ModBox {...styles.modal} underlayColor="TRANSPARENT" onPress={() => setModalVisibility(false)} show={showModal}>
      <Box {...styles.timerComp} top={returnTopValue(layoutValue)} left={returnLeftValue(layoutValue)}>
        {rendeTimerDropdown('hour')}
        {timerSeparator()}
        {rendeTimerDropdown('minute')}
        {timerSeparator()}
        {rendeTimerDropdown('meridian')}
      </Box>
    </ModBox>
  )
}

const renderVirtualCalendarModal = (
  toggleCalendarModal: () => void,
  layoutValueCalendar: {} | any,
  onDateSelected: (date: any) => void,
  isCalendarVisible: boolean,
): ReactElement => {
  return (
    <ModBox
      {...styles.modal}
      underlayColor="TRANSPARENT"
      onPress={() => toggleCalendarModal()}
      testID="toggleCalendarModal"
      show={isCalendarVisible}>
      <Box
        {...styles.timerComp}
        top={returnTopValueCalendar(windowHeight, layoutValueCalendar)}
        left={returnLeftValue(layoutValueCalendar)}>
        <CalendarViewModal
          onDateSelection={onDateSelected}
          dateRange={getRangeDate(new Date(), new Date(new Date().getTime() + 5 * 24 * 60 * 60 * 1000))}
          type={CalendarTypes.SINGLE_FUTURE}
          onCancel={toggleCalendarModal}
        />
      </Box>
    </ModBox>
  )
}
